import React from 'react';
import { TableActionsProps } from '../../interfaces/TableActionsProps';
import { TableActionItem } from './TableActionItem';
import { TableActionMenu } from './TableActionMenu';
import { TableActionTooltip } from './TableActionTooltip';

export const TableActions = <TData,>({
  item,
  actions,
  orientation,
  menu,
  checkedItems,
}: TableActionsProps<TData>) => {
  const tooltipPosition =
    orientation === 'horizontal' ? 'top center' : 'left center';

  return (
    <div className={'action-icons ' + orientation}>
      {actions
        .filter((a) => !a.isHidden?.(item))
        .map((action, index) => {
          return (
            <React.Fragment key={index}>
              {action.tooltipContent ? (
                <TableActionTooltip
                  item={item}
                  position={tooltipPosition}
                  tooltipContent={action.tooltipContent}
                >
                  <div className={'action-icon'}>
                    <TableActionItem
                      checkedItems={checkedItems}
                      action={action}
                      item={item}
                    />
                  </div>
                </TableActionTooltip>
              ) : (
                <div className={'action-icon'}>
                  <TableActionItem
                    checkedItems={checkedItems}
                    action={action}
                    item={item}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      {menu && <TableActionMenu item={item} {...menu} />}
    </div>
  );
};
